
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #1aa197;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 120px;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
</style>
<template>
  <div class="list">
    <div class="item">
      <div class="left">
        <div class="title">记分编号:</div>
        <div class="content">{{ base.scoring_num }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">姓名:</div>
        <div class="content">{{ base.name }}</div>
      </div>
      <div class="right">
        <div class="title">出生日期:</div>
        <div class="content">{{ base.born_date }}</div>
      </div>
    </div>

    <div class="item">
      <div class="left">
        <div class="title">性别:</div>
        <div class="content">
          <span v-if="base.gender == 1">男</span
          ><span v-if="base.gender == 2">女</span>
        </div>
      </div>
      <div class="right">
        <div class="title">测试年龄:</div>
        <div class="content">{{ base.real_age }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">主试姓名:</div>
        <div class="content">{{ base.examiner_name }}</div>
      </div>
      <div class="right">
        <div class="title">测试日期:</div>
        <div class="content">{{ base.test_date }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">是否早产:</div>
        <div class="content" v-if="base.is_premature_infant === '0'">否</div>
        <div class="content" v-if="base.is_premature_infant === '1'">是</div>
      </div>
    </div>
    <div class="item" v-if="base.is_premature_infant === '1'">
      <div class="left">
        <div class="title">预产日期:</div>
        <div class="content">{{ base.expected_date }}</div>
      </div>
      <div class="right">
        <div class="title">矫正后测试年龄:</div>
        <div class="content">{{ base.adjustment_age }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">照护者姓名:</div>
        <div class="content">{{ base.caregivers_name }}</div>
      </div>
      <div class="right">
        <div class="title">与儿童关系:</div>
        <div class="content" v-if="base.relationship_of_child === 'FATHER'">父亲</div>
        <div class="content" v-if="base.relationship_of_child === 'MONTHER'">母亲</div>
        <div class="content" v-if="base.relationship_of_child === 'GRAND_FATHER'">（外）祖父母</div>
        <div class="content" v-if="base.relationship_of_child === 'OTHER'">{{base.relationship_remark}}</div>
      </div>
      
    </div>
    <div class="item">
      <div class="left">
        <div class="title">转介原因:</div>
        <div class="content">{{ base.referral_remark }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object],
  },
  watch: {
    data: {
      handler: function (e) {
        this.base = e;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      base: null,
    };
  },
  created() {
  },
  methods: {},
};
</script>
